<template>
  <div class="news-content">
    <div class="no-data flex flex-direction align-center justify-center">
      <img class="no-data-img" src="../../assets/images/news/no-data.png" />
      <div class="no-data-text">
        暂无相关信息<br />
        请尝试输入不同的关键词来获取更多搜索结果
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "notData",
};
</script>

<style lang="scss" scoped>
@media (min-width: 992px) {
  .news-content {
    width: 100%;
    height: auto;
    min-height: calc(100vh - 600px);
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    background: rgba(255, 255, 255, 0.4);
    border: 1px solid;
    border-image: linear-gradient(
        164deg,
        rgba(255, 255, 255, 1),
        rgba(235, 235, 235, 0)
      )
      1 1;

    .news-item {
      width: 280px;
      //margin-top: 30px;
      cursor: pointer;
      margin-right: 20px;
      .cover {
        width: 281px;
        height: 159px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .content {
        padding: 20px;
        background: rgba(255, 255, 255, 0.8);
        border: 1px solid;
        border-image: linear-gradient(
            157deg,
            rgba(255, 255, 255, 1),
            rgba(235, 235, 235, 0)
          )
          1 1;
      }

      .title {
        min-height: 59px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin: 0;
        font-size: 18px;

        color: #151e26;
        line-height: 1.5;
        height: 59px;
      }

      .desc {
        height: 50px;
        margin-top: 20px;
        font-size: 14px;

        color: #666666;
        line-height: 24px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .info {
        margin-top: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .time {
          font-size: 14px;
          color: #999999;
        }

        .more {
          font-size: 14px;

          color: #b4251e;
          text-decoration: underline;
        }
      }
    }
    .no-data {
      width: 100%;
      height: 500px;
      .no-data-img {
        width: 141px;
        height: 141px;
      }
      .no-data-text {
        height: 66px;
        margin-top: 43px;
        font-size: 18px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #151e26;
        line-height: 33px;
        text-align: center;
      }
    }
  }
}
@media (max-width: 992px) {
  .news-content {
    width: 100%;
    min-height: 35vh;
    flex-direction: column;
    background-color: #eef2f9;
    padding-left: 24px;
    padding-right: 37px;
    padding-bottom: 20px;
    .news-item {
      width: 100%;
      display: flex;

      .cover {
        width: 263px;
        height: 147px;
        flex-shrink: 0;
      }

      .content {
        background: transparent;
        padding: 12px 0 12px 30px;
        border: none;
      }

      .title {
        font-size: 26px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #151e26;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .time {
        font-size: 20px;
      }

      .desc,
      .more {
        display: none;
      }
    }
    .no-data {
      width: 100%;
      height: 1000px;
      .no-data-img {
        width: 212px;
        height: 215px;
      }

      .no-data-text {
        height: 72px;
        margin-top: 42px;
        font-size: 24px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;

        color: #151e26;
        line-height: 36px;
        text-align: center;
      }
    }
  }
}
</style>
